import React, { useState, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-toastify/dist/ReactToastify.css';
import { Formik, Form } from "formik";
import Yup, { validaData } from '../../../../util/Validacoes';
import { mostrarToast } from '../../../../components/Toasts'
import { useParams } from "react-router-dom";
import { get, salvar } from '../../../../util/AcessoApi'
import { HeaderCadastro } from '../../../../components/Headers'
import { Link } from 'react-router-dom'
import { InputDatePicker, InputPadrao } from '../../../../components/Inputs'
import { InputSimNao } from '../../../../components/InputsAutoComplete'
import { BotaoPadrao } from '../../../../components/Botoes'
import { mensagens } from '../../../../util/Utilitarios'
import '../../../../assets/css/icones/iconsmind/style.css'
import Atalho from '../../../../util/Atalho'

const CadastroFeriados = (props) => {
    let { id } = useParams()

    const [salvarENovo, setSalvarENovo] = useState(false)
    const [salvando, setSalvando] = useState(false)
    const [valoresIniciais, setValoresIniciais] = useState({})
    const [validacao] = useState(Yup.object({
        descricao: Yup.string()
            .required().trim()
            .max(200),
        data_feriado: Yup.string().nullable().required()
            .test('Data Inicial', 'Data inválida!', function (value) { return validaData(this.parent.data_feriado) }),
    }))
    const manter = ['']

    const Submit = (values, propsFormik) => {
        setSalvando(true)
        salvar(
            values,
            '/administracao/feriados',
            () => {
                mostrarToast('sucesso', mensagens.sucesso)

                if (salvarENovo) {
                    propsFormik.resetForm({})
                    manter.forEach(x => propsFormik.setFieldValue(x, values[x]))
                    setSalvando(false)
                }
                else
                    props.history.push('/administracao/feriados/consulta')
            },
            () => {
                setSalvando(false)
            })
    }

    useEffect(() => {
        Promise.resolve(get(`/administracao/feriados/${id}`)).then(obj => {
            if (id && !obj.data_feriado)
                props.history.push('/administracao/feriados/consulta')
            else if (id) {
                setValoresIniciais(obj)
            }
            else {
                setValoresIniciais({
                    descricao: "",
                    data_feriado: ""
                })
            }
        })
    }, [id])

    return (
        <Formik
            initialValues={valoresIniciais}
            validationSchema={validacao}
            enableReinitialize={true}
            onSubmit={(values, propsFormik) => Submit(values, propsFormik)}>
            {propsFormik => (<Form>
                <div className={props.modal && props.modal || 'card mb-20'}>
                    <div className={props.modal || 'card-body'}>
                        <div className='row'>
                            <InputPadrao label='Id' name='id' type='hidden' placeholder='Id' obrigatorio={false} />
                            <InputPadrao label='Nome Feriado' name='descricao' type='text' placeholder='Nome Feriado' classeTooltip={props.modal && 'tooltip-input-modal'}
                                obrigatorio={true} tamanho={!props.modal && 'col-6 col-sm-12 col-md-6 col-xl-6'} />

                            <InputPadrao label='Observação' name='observacao' type='text' placeholder='Observação' classeTooltip={props.modal && 'tooltip-input-modal'}
                                tamanho={!props.modal && 'col-6 col-sm-12 col-md-6 col-xl-6'} />
                            <InputDatePicker tamanho={!props.modal && "col-lg-3 col-md-12"} label="Data" name="data_feriado" type="text" obrigatorio="true"
                                setarValor={value => {
                                    propsFormik.setFieldValue("data_feriado", value)
                                }} classeTooltip={props.modal && 'tooltip-input-modal'}
                            />
                            <Atalho formik={propsFormik} salvando={salvando} setSalvareNovo={setSalvarENovo} salvarENovo={true} />

                        </div>
                    </div>
                </div>
                {!props.modal ? <div className='separator mt-40 mb-5'></div> : <></>}
                <div className='direita container-botoes mb-3 group-salvar-novo'>
                    <BotaoPadrao texto='Salvar' disabled={salvando} click={_ => setSalvarENovo(false)} idTooltip={'salvar'} />
                    {!id && <BotaoPadrao texto='Salvar e Novo' disabled={salvando} click={_ => setSalvarENovo(true)} idTooltip={'salvarENovo'} />}
                </div>
            </Form>)
            }
        </Formik >
    );
}

const Cadastro = (props) => {
    const links = [
        () => <Link to={'/dashboard'}>Dashboard</Link>,
        () => <Link to={'#'}>Administrativo</Link>,
        () => <Link className="link-active" to={'/administracao/feriados/consulta'}>Feriados</Link>,
    ]
    return (<>
        {!props.modal && <HeaderCadastro titulo={"Cadastro de Feriados"} link={links} />}
        <CadastroFeriados {...props} />
    </>
    )
}
export { CadastroFeriados }
export default Cadastro
